import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "theme-switch-wrapper" }
const _hoisted_2 = {
  class: "theme-switch",
  for: "checkbox"
}
const _hoisted_3 = ["checked"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "slider round" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("em", null, "Modo oscuro!", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.toggleTheme && $setup.toggleTheme(...args))),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.isDarkTheme) = $event)),
          type: "checkbox",
          id: "checkbox",
          checked: $setup.isDarkTheme
        }, null, 8, _hoisted_3), [
          [_vModelCheckbox, $setup.isDarkTheme]
        ]),
        _hoisted_4
      ]),
      _hoisted_5
    ])
  ]))
}